import { render, staticRenderFns } from "./SupervisorRemainingSamples.vue?vue&type=template&id=d9341622"
import script from "./SupervisorRemainingSamples.vue?vue&type=script&lang=js"
export * from "./SupervisorRemainingSamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports